function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 310 259.34375",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(10.015625,-803.03125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3785-0",
    d: "m 19.668179,1032.694 250.646101,0 0,0",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 49.33635712,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3785-0-9",
    d: "m 19.668179,932.694 250.646101,0 0,0",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 49.33635712,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3785-0-4",
    d: "m 19.668179,832.694 250.646101,0 0,0",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 49.33635712,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.9798456698233c099933a45ca7881707.svg";
export { ForwardRef as ReactComponent };